import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { getTemplates } from '@ducks/conectoresTemplates';

export default function TableTemplates() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');
  const { idGrupo } = useParams();

  const templates = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('templates').toArray());
  const loadingTemplates = useSelector(({ conectoresTemplates }) => conectoresTemplates.get('loadingTemplates'));

  const handleSearch = () => {
    dispatch(getTemplates(idGrupo));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Template',
      dataIndex: 'ds',
      key: 'ds',
      width: '85%',
      ...TableSearch('ds', 'template', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/templates/cadastro/${idGrupo}/${text}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={templates} loading={loadingTemplates} hidePagination />;
}
